// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM6 8.5H11V18H13V8.5H18V6.5H6V8.5Z"}}]};

const TextboxFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'textbox-filled',
    ref,
    icon: element,
  },
));

TextboxFilledIcon.displayName = 'TextboxFilledIcon';

export default TextboxFilledIcon;
